export default __webpack_public_path__ + "static/en-95c7c68e16c065ff924c98b73bc2e838.png";